<template>
  <div class="countdown-timer">
    <svg :height="t_size" :width="t_size">
      <circle
        class="counter-hole"
        cx="50%"
        cy="50%"
        :r="t_radius"
        fill="rgba(99,99,99, 0.1)"
      ></circle>
      <circle
        class="counter-ring"
        cx="50%"
        cy="50%"
        :r="t_radius"
        fill="transparent"
        stroke="transparent"
        :stroke-width="t_stroke"
      ></circle>
      <circle
        class="counter-segment"
        :class="segmentClasses"
        cx="50%"
        cy="50%"
        :r="t_radius"
        fill="transparent"
        :stroke-width="t_stroke"
        :stroke-dasharray="t_dasharray"
      ></circle>
      <g class="chart-text">
        <text :x="t_text" y="50%" class="counter-number" :style="{}">{{ m_counter }}</text>
      </g>
    </svg>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'IpsCountdown',
  props: {
    classes: {
      name: 'classes',
      description: 'The classes of the countdown',
      type: [String, Array],
      default: 'alert-primary',
      required: false,
    },
    initialCounter: {
      name: 'initialCounter',
      description: 'The initial value of the countdown',
      type: Number,
      required: true,
    },
    size: {
      name: 'size',
      description: 'The size of the countdown',
      type: Number,
      default: 40,
      required: false,
    },
    stroke: {
      name: 'stroke',
      description: 'The size stroke size',
      type: Number,
      default: 3,
      required: false,
    },
  },
  data() {
    return {
      counterTimeout: undefined,
      m_counter: this.initialCounter,
    };
  },
  computed: {
    t_size() {
      return this.size;
    },
    t_radius() {
      return this.t_size / 2 - this.t_stroke;
    },
    t_stroke() {
      return this.stroke;
    },
    t_circumference() {
      return this.t_radius * 2 * Math.PI;
    },
    t_percent() {
      return (this.m_counter / this.initialCounter) * 100;
    },
    t_dasharray() {
      return `${this.t_percent} ${this.t_circumference * this.t_percent * 10}`;
    },
    t_text() {
      if (this.m_counter < 10) return '40%';
      return '30%';
    },
    segmentClasses() {
      const arr = [];
      if (this.classes) arr.push(this.classes);
      return arr;
    },
    counter() {
      return this.m_counter;
    },
  },
  mounted() {
    const vm = this;
    Vue.nextTick(() => {
      if (vm.m_counter > 0) vm.startCountdown();
    });
  },
  methods: {
    complete() {
      if (this.counterTimeout) this.counterTimeout = undefined;
      this.$emit('timeout');
    },
    startCountdown() {
      if (!this.counterTimeout) {
        if (this.m_counter === 0 || !this.m_counter) {
          return;
        }
        // Start timeout
        this.counterTimeout = setTimeout(this.onTimeout.bind(this), 1000);
      }
    },
    onTimeout() {
      if (this.m_counter > 0) {
        this.m_counter -= 1;
      }

      if (this.m_counter >= 1) {
        this.counterTimeout = setTimeout(this.onTimeout.bind(this), 1000);
      } else {
        clearTimeout(this.counterTimeout);
        this.complete();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsCountdown';
</style>
